export default "__VITE_ASSET__CzDMdSSw__"